
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-ideas",
      function () {
        return require("private-next-pages/gift-ideas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-ideas"])
      });
    }
  